import { render, staticRenderFns } from "./Otp.vue?vue&type=template&id=233addeb&scoped=true"
import script from "./Otp.vue?vue&type=script&lang=js"
export * from "./Otp.vue?vue&type=script&lang=js"
import style0 from "./Otp.vue?vue&type=style&index=0&id=233addeb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233addeb",
  null
  
)

export default component.exports